import { createFileRoute, Outlet } from '@tanstack/react-router';

import { ProductGuard } from '@/components/upsell/ProductGuard';

export const Route = createFileRoute('/savi')({
    component: () => (
        <ProductGuard product="savi">
            <Outlet />
        </ProductGuard>
    ),
});
